<template>
  <div class="deslocation row align-center">
    <img src="../../assets/img/gps.svg" />
    <div class="warning">
      Você está em deslocamento para o
      <strong>Job {{modal.id}}</strong>
    </div>
    <span>FECHANDO EM {{count}}...</span>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.deslocation {
  padding: 45px 35px;
  width: 500px;
  img {
    margin-right: 31px;
  }
  .warning {
    font-size: 26px;
    width: 180px;
  }
  span{
    color: $gray-9;
    font-size: 15px;
    margin-left: 100px;
  }
}
</style>

<script>

export default {
  name: "Deslocation",
  props: {
    modal: Object
  },
  data() {
    return {
      count: 5
    };
  },
  methods: {
    county(){
      if(this.count>0) {
        this.count = this.count-1
        setTimeout(()=>{this.county()},1000);
      }else{
        this.modal.show = false
      }
    }
  },
  mounted(){  
    this.county()
  },
  computed: {
    
  }
};
</script>
